import { Controller } from "@hotwired/stimulus"

// Handles privacy mode toggle for blurring sensitive currency values
// Activated via menu toggle or keyboard shortcut (Cmd/Ctrl + Shift + P)
//
// Persisted in localStorage, not sessionStorage: the setting exists so the app can be
// demoed or screen-shared without exposing account values, and a per-tab setting meant
// re-enabling it every time. Once it is on, it stays on.
const STORAGE_KEY = "privacyMode"

export default class extends Controller {
  static targets = ["indicator"]

  connect() {
    // Restore privacy mode state from local storage
    if (localStorage.getItem(STORAGE_KEY) === "true") {
      this.enable()
    } else {
      this.updateIndicator(false)
    }
    this.boundHandleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.boundHandleKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundHandleKeydown)
  }

  toggle(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    document.body.classList.contains("privacy-mode") ? this.disable() : this.enable()
  }

  enable() {
    document.body.classList.add("privacy-mode")
    localStorage.setItem(STORAGE_KEY, "true")
    this.updateIndicator(true)
  }

  disable() {
    document.body.classList.remove("privacy-mode")
    localStorage.setItem(STORAGE_KEY, "false")
    this.updateIndicator(false)
  }

  updateIndicator(enabled) {
    if (this.hasIndicatorTarget) {
      this.indicatorTarget.textContent = enabled ? "ON" : "OFF"
    }
  }

  handleKeydown(event) {
    // Cmd/Ctrl + Shift + P
    if ((event.metaKey || event.ctrlKey) && event.shiftKey && event.key.toLowerCase() === "p") {
      event.preventDefault()
      this.toggle()
    }
  }
}
